// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Button } from "@hex-insights/core";
import { AddSubFormButtonRenderProps, Form, SubFormField, SubFormRenderProps, TextField } from "@hex-insights/forms";
import { BuildingFormValues, CampusFormValues } from "../../FormUtilities";
import { BuildingForm, BuildingSelectField } from "../Building";
import { CountrySelectField } from "../Country";
import { EmployeeSelectField } from "../Employee";
import { BaseFieldProps } from "../shared";

/**
 * Generic props for fields of the Campus model.
 */
type FieldProps<K extends keyof CampusFormValues.Base = keyof CampusFormValues.Base> = BaseFieldProps<
	Pick<CampusFormValues.Base, K>
>;

/**
 * Generic props for fields of the Campus model that only appear in the create form.
 */
type CreateFieldProps<K extends keyof CampusFormValues.Create = keyof CampusFormValues.Create> = BaseFieldProps<
	Pick<CampusFormValues.Create, K>
>;

/**
 * Generic props for fields of the Campus model that only appear in the detail form.
 */
type DetailFieldProps<K extends keyof CampusFormValues.Detail = keyof CampusFormValues.Detail> = BaseFieldProps<
	Pick<CampusFormValues.Detail, K>
>;

/**
 * Field component for the `name` field of the Campus model.
 */
export function Name({ formState, ...props }: FieldProps<"name">) {
	return <TextField formState={formState} name="name" {...props} />;
}

/**
 * Field component for the `phoneNumber` field of the Campus model.
 */
export function PhoneNumber({ formState, ...props }: FieldProps<"phoneNumber">) {
	return <TextField formState={formState} name="phoneNumber" {...props} />;
}

/**
 * Field component for the `addressLine1` field of the Campus model.
 */
export function AddressLine1({ formState, ...props }: FieldProps<"addressLine1">) {
	return <TextField formState={formState} name="addressLine1" {...props} />;
}

/**
 * Field component for the `addressLine2` field of the Campus model.
 */
export function AddressLine2({ formState, ...props }: FieldProps<"addressLine2">) {
	return <TextField formState={formState} name="addressLine2" optional {...props} />;
}

/**
 * Field component for the `city` field of the Campus model.
 */
export function City({ formState, ...props }: FieldProps<"city">) {
	return <TextField formState={formState} name="city" {...props} />;
}

/**
 * Field component for the `postalCode` field of the Campus model.
 */
export function PostalCode({ formState, ...props }: FieldProps<"postalCode">) {
	return <TextField formState={formState} name="postalCode" optional {...props} />;
}

/**
 * Field component for the `stateOrProvince` field of the Campus model.
 */
export function StateOrProvince({ formState, ...props }: FieldProps<"stateOrProvince">) {
	return <TextField formState={formState} name="stateOrProvince" optional {...props} />;
}

export namespace Buildings {
	export type SelectProps = DetailFieldProps<"buildingIDs"> &
		Omit<BuildingSelectField.MultiSelectProps<CampusFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `buildings` edge of the Campus model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <BuildingSelectField.MultiSelect formState={formState} name="buildingIDs" {...props} />;
	}

	/**
	 * SubForm field component for the `buildings` edge of the Campus model.
	 */
	export function SubForm({ formState, ...props }: CreateFieldProps<"buildings">) {
		return (
			<SubFormField formState={formState} name="buildings" blankItem={BuildingFormValues.blankItemInCampus} {...props}>
				{SubForm.SubForm}
				{SubForm.AddButton}
			</SubFormField>
		);
	}

	SubForm.SubForm = function ({ formState, onRemoveClick }: SubFormRenderProps<BuildingFormValues.CreateInCampus>) {
		return (
			<Form.Column>
				<Button variant="tertiary" size="small" onClick={onRemoveClick} disabled={formState.disabled}>
					Remove Building
				</Button>
				<BuildingForm.CreateFieldsInCampus formState={formState} />
			</Form.Column>
		);
	};

	SubForm.AddButton = function ({
		onClick,
		disabled,
	}: AddSubFormButtonRenderProps<Pick<CampusFormValues.Create, "buildings">, BuildingFormValues.CreateInCampus>) {
		return (
			<Button variant="tertiary" size="small" onClick={onClick} disabled={disabled}>
				Add Building
			</Button>
		);
	};
}

export namespace Country {
	export type SelectProps = FieldProps<"countryID"> &
		Omit<CountrySelectField.SelectProps<CampusFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `country` edge of the Campus model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <CountrySelectField.Select formState={formState} name="countryID" {...props} />;
	}
}

export namespace Employees {
	export type SelectProps = FieldProps<"employeeIDs"> &
		Omit<EmployeeSelectField.MultiSelectProps<CampusFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `employees` edge of the Campus model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <EmployeeSelectField.MultiSelect formState={formState} name="employeeIDs" {...props} />;
	}
}
